const Affectation_Salle = () => {
    return ( <>
        <h1>Affectation Salle</h1>
    </> );
}
 
export default Affectation_Salle;